import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  reqPath: string;

  constructor(
    private httpClient: HttpClient,
    private handler: HttpBackend
  ) { }

  getResource(key: string): void {
    this.reqPath = key;
  }

  getHttpClientInstance(isHandlerRequired: boolean = false): HttpClient {
    let httpClientInstance = this.httpClient;

    //httpClientInstance.options

    return isHandlerRequired ?
      httpClientInstance = new HttpClient(this.handler) : httpClientInstance;
  }

  private getAuthHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = sessionStorage.getItem('auth-token');
    if (token) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  find<T>(key: string, isHandlerRequired: boolean = false): any {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath);
  }

  findSetting<T>(key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath);
  }

  findOne<T>(id: any, key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath + id);
  }

  findAll<T>(key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath);
  }

  findUsingOptions<T>(key: string, options: any, isHandlerRequired: boolean = false): any {
    this.reqPath = key;
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath, options);
  }

  findByPost<T>(key: string, item: any, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).post<T>(this.reqPath, item);
  }

  save<T>(key: string, item: any, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).post<T>(this.reqPath, item);
  }

  saveUsingOptions<T>(key: string, item: any, options: any, isHandlerRequired: boolean = false): Observable<HttpEvent<T>> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).post<T>(this.reqPath, item, options);
  }

  update<T>(key: string, item: any, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).put<T>(this.reqPath, item);
  }

  updateWithoutItem<T>(key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).put<T>(this.reqPath, {});
  }

  updateUsingOptions<T>(key: string, item: any, options: any, isHandlerRequired: boolean = false): Observable<HttpEvent<T>> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).put<T>(this.reqPath, item, options);
  }

  remove<T>(key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).delete<T>(this.reqPath);
  }

  removeUsingOptions<T>(key: string, item: any, headers: any, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    const options = { headers: headers ? headers : null, body: item ? item : null };
    return this.getHttpClientInstance(isHandlerRequired).delete<T>(this.reqPath, options);
  }

  search<T>(keyword: any, key: string, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    return this.getHttpClientInstance(isHandlerRequired).get<T>(this.reqPath + keyword);
  }

  upload<T>(key: string, item: any, isHandlerRequired: boolean = false, requestId:string): Observable<T> {
    this.getResource(key);
    let headers = new HttpHeaders();
    headers = headers.append('Request-Id', requestId);
    //const options = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + sessionStorage.getItem('auth-token') }) };
    return this.getHttpClientInstance(isHandlerRequired).post<T>(this.reqPath, item, { headers: headers });
  }

  uploadWithToken<T>(key: string, item: any, isHandlerRequired: boolean = false): Observable<T> {
    this.getResource(key);
    const headers = this.getAuthHeaders();
    return this.getHttpClientInstance(isHandlerRequired).post<T>(this.reqPath, item, { headers: headers });
  }

  download<T>(key: string, isHandlerRequired: boolean = false): Observable<any> {
    this.getResource(key);
    let headers = this.getAuthHeaders();
    headers = headers.append('content-type', 'application/octet-stream');
    return this.getHttpClientInstance(isHandlerRequired).get(this.reqPath, {
      headers: headers, responseType: 'blob'
    }
    );
  }
}
